/**
 * Get uniba header slim configuration action
 * @module src/actions/getUnibaHeaderSlimConfig
 */
export const GET_UNIBA_FOOTER_LINKS = 'GET_UNIBA_FOOTER_LINKS';

/**
 * Get uniba footer links configuration.
 * @function getUnibaFooterLinksConfig
 * @returns {Object} Get uniba footer links configuration action.
 */
export function getUnibaFooterLinksConfig(params) {
  return {
    type: GET_UNIBA_FOOTER_LINKS,
    request: {
      op: 'get',
      path: `/@getFooterLinksUniba`,
      params: params,
    },
  };
}
